// ══════════════════════════════════════════════════════════════
// RACHA DE DÍAS CONSECUTIVOS: escritura en Firestore (04/11/2026)
//
// Separado de firebase-config.ts, igual que firebase-chat.ts.
// Usa una transacción: si el alumno tiene la app abierta en dos
// pestañas (o en el celu y la compu a la vez), la racha suma 1 solo
// una vez por día y nunca se pisa.
// ══════════════════════════════════════════════════════════════

import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase-config";
import { calcularNuevaRacha, EstadoRacha, getDiaClave } from "./utils/racha";

/**
 * Registra que el usuario entró hoy y actualiza su racha.
 * Devuelve el estado final, o null si su documento todavía no existe.
 */
export async function RegistrarConexionDiaria(uid: string): Promise<EstadoRacha | null> {
  const ref = doc(db, "Usuarios", uid);
  const hoy = getDiaClave();

  return runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    if (!snap.exists()) return null;

    const data = snap.data();
    const { estado, cambio } = calcularNuevaRacha(
      {
        RachaActual: data.RachaActual,
        RachaMaxima: data.RachaMaxima,
        UltimaConexion: data.UltimaConexion,
      },
      hoy,
    );

    if (cambio) {
      tx.update(ref, {
        RachaActual: estado.RachaActual,
        RachaMaxima: estado.RachaMaxima,
        UltimaConexion: estado.UltimaConexion,
        UltimaConexionEl: serverTimestamp(),
      });
    }
    return estado;
  });
}
